// src/components/MobileNavBar.js
import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './MobileNavBar.css';

// Import your AI-generated logos
import homeIcon from '../assets/images/home.webp';
import productsIcon from '../assets/images/spice.webp'; // Assuming 'whole_spices_icon' for Products
import spiceboxIcon from '../assets/images/gift.webp'; // Assuming 'gift_box_icon' for Spicebox
import whatsappIcon from '../assets/images/whatsapplogo.webp';

const MobileNavBar = ({ whatsappPhoneNumber, whatsappMessage }) => {
    const location = useLocation();
    const [activePath, setActivePath] = useState(location.pathname);

    useEffect(() => {
        setActivePath(location.pathname);
    }, [location.pathname]);

    // Function to determine if a link is active for styling
    const isActiveLink = (path) => activePath === path || (path === '/products' && activePath.startsWith('/products/'));

    return (
        <nav className="mobile-nav-bar">
            <NavLink to="/" className={`nav-item ${isActiveLink('/') ? 'active' : ''}`}>
                <img src={homeIcon} alt="Home" className="nav-icon" />
                <span className="nav-text">Home</span>
            </NavLink>

            <NavLink to="/products/The%20Chai%20Lovers" className={`nav-item ${isActiveLink('/premium-gift-boxes') ? 'active' : ''}`}>
                <img src={spiceboxIcon} alt="Spicebox" className="nav-icon" />
                <span className="nav-text">The Chai Lovers</span>
            </NavLink>

            <NavLink to="/products" className={`nav-item ${isActiveLink('/whole-spices') ? 'active' : ''}`}>
                <img src={productsIcon} alt="Products" className="nav-icon" />
                <span className="nav-text">All Products</span>
            </NavLink>

            {/* Assuming /spice-gift-boxes for Spicebox. Adjust route if needed. */}
            

            <a
                href={`https://wa.me/${whatsappPhoneNumber}?text=${encodeURIComponent(whatsappMessage)}`}
                className="nav-item whatsapp-nav-item"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat with us on WhatsApp"
            >
                <img src={whatsappIcon} alt="WhatsApp" className="nav-icon" />
                <span className="nav-text">WhatsApp</span>
            </a>
        </nav>
    );
};

export default MobileNavBar;